var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card asset_header"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm._f("nameOrID")(_vm.asset)) + " "), _c('span', {
    staticClass: "symbol"
  }, [_vm._v(_vm._s(_vm.asset.symbol))])])]), _c('div', {
    staticClass: "two_column"
  }, [_c('Metadata', {
    attrs: {
      "asset": _vm.asset,
      "genesis-tx": _vm.genesisTx
    }
  }), _c('section', [_vm.isNFT ? _c('NFTRenderer', {
    attrs: {
      "asset": _vm.asset
    }
  }) : _vm._e()], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }